// extracted by mini-css-extract-plugin
module.exports = {"body":"_93444fe79c--body--1tNqc"};